import { Component, OnInit } from '@angular/core';
import { ButtonCode } from '../../buttoncode.interface';
import { GpioService } from '../../gpio.service';

@Component({
  selector: 'app-inputs',
  templateUrl: './inputs.component.html',
  styleUrls: ['./inputs.component.scss']
})
export class InputsComponent implements OnInit {
  public red1: boolean = false;
  public yellow1: boolean = false;
  public blue1: boolean = false;

  constructor(
    private gpioService: GpioService
  ) { }

  ngOnInit(): void {
    this.gpioService.buttonEvents$.subscribe(event => {
      switch (event.code)
      {
        case ButtonCode.Red1:
          this.red1 = event.type == 'down';
          break;

        case ButtonCode.Yellow1:
          this.yellow1 = event.type == 'down';
          break;

        case ButtonCode.Blue1:
          this.blue1 = event.type == 'down';
          break;
      }
    });
  }

}
